import React, { useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/router';

import SearchIcon from '../Icons/Search';
import MobileSearchModal from '../Modals/MobileSearchModal';

import colors from '../../utils/colorConstants';

// const MobileSearchField = ({ startingValue, onDismiss }: any) => {
const MobileSearchField = ({ startingValue }: any) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const router = useRouter();
  const { query } = router;
  const { q = '' } = query;

  // const dismiss = () => {
  //   onDismiss(searchInputRef?.current?.value || undefined);
  // };

  // const searchSubmit = (event: any) => {
  //   event.preventDefault();

  //   const searchQuery = event.target?.[0]?.value || "";

  //   fastpanel({
  //     name: "pbr_search_requested",
  //     data: {
  //       entry_point: "all",
  //       searched_for: query,
  //     },
  //   });

  //   const href = query ? `/search?q=${searchQuery}` : `/cards`;
  //   router.push(href);
  //   dismiss();
  // };

  const searchToggleCallback = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  useEffect(() => {
    if (searchInputRef.current) {
      if (searchInputRef.current.value !== q) {
        searchInputRef.current.value = '';
      }
    }
  }, [q]);

  return (
    <>
      <div className="flex w-full h-14 px-4 items-center">
        <div className="flex relative w-full lg:w-3/4 lg:max-w-[720px] mx-auto items-center">
          <input
            autoCapitalize="none"
            className={
              'block w-full paragraph-small bg-gallery text-lapel placeholder-charcoal border-dove py-0 h-10 pl-10 pr-6 rounded-full border-alto lg:pr-10 focus:ring-gatsby focus:border-gatsby'
            }
            defaultValue={q}
            onFocus={() => {
              // Immediately blur the input -- we're basically just using it as a button
              searchInputRef.current?.blur();
              searchToggleCallback();
            }}
            placeholder="Search by design, theme, or category"
            ref={searchInputRef}
            type="text"
          />
          <div className="absolute w-6 h-6 left-3 items-center">
            <SearchIcon fill={colors.charcoal} height="1.5rem" width="1.5rem" />
          </div>
        </div>
      </div>
      <MobileSearchModal
        className="absolute top-0 left-0"
        isOpen={isSearchOpen}
        onDismiss={searchToggleCallback}
        startingValue={startingValue || q?.toString() || ''}
      />
    </>
  );
};

export default MobileSearchField;
